/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessNumber } from '../../models/access-number';

export interface GetAccessnumber$Plain$Params {
  'api-version'?: string;
}

export function getAccessnumber$Plain(http: HttpClient, rootUrl: string, params?: GetAccessnumber$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccessNumber>>> {
  const rb = new RequestBuilder(rootUrl, getAccessnumber$Plain.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AccessNumber>>;
    })
  );
}

getAccessnumber$Plain.PATH = '/accessnumber';
